export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4617.20cdbf2c.jpg";